// import React, { useState } from 'react';
// import {
//     FormControl,
//     InputLabel,
//     MenuItem,
//     Select,
//     TextField,
//     Radio,
//     RadioGroup,
//     FormControlLabel,
// } from '@mui/material';
// import { Link } from 'react-router-dom';
// import { PayPalScriptProvider, PayPalButtons } from '@paypal/react-paypal-js';
// import styles from './checkout.module.scss';

// const Checkout = () => {
//     const [paymentMethod, setPaymentMethod] = useState('creditCard');

//     const handlePaymentMethodChange = (event) => {
//         setPaymentMethod(event.target.value);
//     };

//     const handlePayPalApprove = (data, actions) => {
//         return actions.order.capture().then(function (details) {
//             alert('Transaction completed by ' + details.payer.name.given_name);
//             // Handle successful transaction here (e.g., redirect, show success message)
//         });
//     };

//     const handleCreditCardSubmit = (event) => {
//         event.preventDefault();
//         // Handle credit card form submission (not implemented in this example)
//         // You might want to add form validation and submission logic here
//         alert('Credit card payment submitted');
//     };

//     const renderPaymentFields = () => {
//         if (paymentMethod === 'creditCard') {
//             return (
//                 <>
//                     <div className={styles.heading_cont}>
//                         <h3>Payment Info</h3>
//                         <div>
//                             <img src='./assets/visa.png' alt="Visa" />
//                             <img src='./assets/mastercard.png' alt="Mastercard" />
//                         </div>
//                     </div>
//                     <form onSubmit={handleCreditCardSubmit}>
//                         <div className={styles.input_fields_cont}>
//                             <TextField id="card-number" label="Card number" variant="outlined" />
//                         </div>
//                         <div className={styles.input_fields_cont}>
//                             <TextField id="expiration" label="Expiration MM/YY" variant="outlined" />
//                             <TextField id="security-code" label="Security Code" variant="outlined" />
//                         </div>
//                         <div className={styles.input_fields_cont}>
//                             <TextField id="billing-zip" label="Billing ZIP Code" variant="outlined" />
//                         </div>
//                         <div className={styles.button_cont}>
//                             <button type="submit">Submit Order</button>
//                         </div>
//                     </form>
//                 </>
//             );
//         } else if (paymentMethod === 'paypal') {
//             return (
//                 <div id="paypal-buttons">
//                     <PayPalButtons
//                         style={{ layout: 'horizontal' }}
//                         createOrder={(data, actions) => {
//                             return actions.order.create({
//                                 purchase_units: [{
//                                     amount: {
//                                         value: '1.00' // Replace with your dynamic value
//                                     }
//                                 }]
//                             });
//                         }}
//                         onApprove={handlePayPalApprove}
//                         options={{
//                             clientId: 'YOUR_SANDBOX_CLIENT_ID',
//                             currency: 'USD',
//                             vault: true
//                         }}
//                     />
//                 </div>
//             );
//         }
//     };

//     return (
//         <div className={styles.checkout_cont}>
//             <div className='container'>
//                 <h2>Enter Payment Info</h2>
//                 <div className={styles.heading_cont}>
//                     <h3>Shipping Address</h3>
//                     <div>
//                         <p>Already have an account?</p>
//                         <Link to="/signin">Sign in</Link>
//                     </div>
//                 </div>
//                 <div className={styles.input_fields_cont}>
//                     <TextField id="first-name" label="First Name" variant="outlined" />
//                     <TextField id="last-name" label="Last Name" variant="outlined" />
//                 </div>
//                 <div className={styles.input_fields_cont}>
//                     <TextField id="email" label="Email (Required)" variant="outlined" />
//                     <TextField id="phone" label="Phone (Required)" variant="outlined" />
//                 </div>
//                 <div className={styles.input_fields_cont}>
//                     <TextField id="address" label="Address" variant="outlined" />
//                 </div>
//                 <div className={styles.input_fields_cont}>
//                     <TextField id="apt-suite" label="Apt, Suite, Unit, etc. (Optional)" variant="outlined" />
//                 </div>
//                 <div className={styles.input_fields_cont}>
//                     <TextField id="city" label="City" variant="outlined" />
//                 </div>
//                 <div className={styles.input_fields_cont}>
//                     <FormControl>
//                         <InputLabel id="state-label">State</InputLabel>
//                         <Select
//                             labelId="state-label"
//                             id="state"
//                             label="State"
//                         >
//                             <MenuItem value="Karnataka">Karnataka</MenuItem>
//                             <MenuItem value="Maharashtra">Maharashtra</MenuItem>
//                             <MenuItem value="West Bengal">West Bengal</MenuItem>
//                         </Select>
//                     </FormControl>
//                     <TextField id="zip-code" label="Zip code" variant="outlined" />
//                 </div>

//                 <div className={styles.heading_cont}>
//                     <h3>Payment Method</h3>
//                 </div>
//                 <RadioGroup
//                     aria-label="payment-method"
//                     name="payment-method"
//                     value={paymentMethod}
//                     onChange={handlePaymentMethodChange}
//                 >
//                     <FormControlLabel
//                         value="creditCard"
//                         control={<Radio />}
//                         label="Credit Card"
//                     />
//                     <FormControlLabel
//                         value="paypal"
//                         control={<Radio />}
//                         label="PayPal"
//                     />
//                 </RadioGroup>

//                 {renderPaymentFields()}
//             </div>
//         </div>
//     );
// };

// export default Checkout;


import React, { useState } from 'react';
import axios from 'axios';
import ProtectedPaymentRoute from '../../auth/Auth';

const Checkout = () => {
  ProtectedPaymentRoute()

  const [billingAddress, setBillingAddress] = useState({
    line1: '',
    city: '',
    state: '',
    postal_code: '',
    country_code: 'US',  // Example: default to US
  });

  const [cardInfo, setCardInfo] = useState({
    number: '',
    expire_month: '',
    expire_year: '',
    cvv2: '',
    first_name: '',
    last_name: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('billing_')) {
      setBillingAddress({ ...billingAddress, [name.slice(8)]: value });
    } else if (name.startsWith('card_')) {
      setCardInfo({ ...cardInfo, [name.slice(5)]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post('/api/paypal/payment', {
        billingAddress,
        cardInfo,
        amount: 100.00,  // Replace with actual amount
        currency: 'USD', // Replace with appropriate currency
      });

      console.log('Payment successful:', response.data);
      // Handle success (e.g., show confirmation to user)
    } catch (error) {
      console.error('Payment error:', error);
      // Handle error (e.g., show error message to user)
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Payment Information</h2>

      <label>Billing Address:</label>
      <input type="text" name="billing_line1" placeholder="Address Line 1" onChange={handleInputChange} required />
      <input type="text" name="billing_city" placeholder="City" onChange={handleInputChange} required />
      <input type="text" name="billing_state" placeholder="State" onChange={handleInputChange} required />
      <input type="text" name="billing_postal_code" placeholder="Postal Code" onChange={handleInputChange} required />

      <label>Card Information:</label>
      <input type="text" name="card_number" placeholder="Card Number" onChange={handleInputChange} required />
      <input type="text" name="card_expire_month" placeholder="Expiration Month (MM)" onChange={handleInputChange} required />
      <input type="text" name="card_expire_year" placeholder="Expiration Year (YYYY)" onChange={handleInputChange} required />
      <input type="text" name="card_cvv2" placeholder="CVV2" onChange={handleInputChange} required />
      <input type="text" name="card_first_name" placeholder="Card Holder's First Name" onChange={handleInputChange} required />
      <input type="text" name="card_last_name" placeholder="Card Holder's Last Name" onChange={handleInputChange} required />

      <button type="submit">Pay Now</button>
    </form>
  );
};

export default Checkout;

